<template>
  <v-card class="py-4 custom-height" id="style-2">
    <div name="headerScore" class="header-score">
      <div class="content-score">
        <div class="tilte py-2">Điểm kiểm tra</div>
        <div class="score py-2" v-if="dataDetailSkill">
          <span style="color: #00cc60">{{ dataDetailSkill.overall.score }}</span
          >/10
        </div>
        <div class="tag-ex py-2" v-if="dataDetailSkill">
          Hoàn thành {{ totalCorrectQuestion }}/{{
            totalQuestion
          }}
        </div>
      </div>
      <div class="mt-4 d-flex justify-space-between">
        <div class="content-skill">
          <div class="title">Nghe</div>
          <div class="score" v-if="dataDetailSkill">
            <span style="color: #2ca9e2">{{
              dataDetailSkill.overall.listening_score.split("/")[0]
            }}</span
            >/{{ dataDetailSkill.overall.listening_score.split("/")[1] }}
          </div>
        </div>
        <div class="content-skill">
          <div class="title">Nói</div>
          <div class="score" v-if="dataDetailSkill">
            <span style="color: #2ca9e2">{{
              dataDetailSkill.overall.speaking_score.split("/")[0]
            }}</span
            >/{{ dataDetailSkill.overall.speaking_score.split("/")[1] }}
          </div>
        </div>
        <div class="content-skill">
          <div class="title">Đọc</div>
          <div class="score" v-if="dataDetailSkill">
            <span style="color: #2ca9e2">{{
              dataDetailSkill.overall.reading_score.split("/")[0]
            }}</span
            >/{{ dataDetailSkill.overall.reading_score.split("/")[1] }}
          </div>
        </div>
        <div class="content-skill">
          <div class="title">Viết</div>
          <div class="score" v-if="dataDetailSkill">
            <span style="color: #2ca9e2">{{
              dataDetailSkill.overall.writing_score.split("/")[0]
            }}</span
            >/{{ dataDetailSkill.overall.writing_score.split("/")[1] }}
          </div>
        </div>
      </div>
    </div>
    <div name="bodyScore" class="p-4 body-score">
      <div class="feedback">Nhận xét</div>
      <div class="px-4 pt-4">
        <div class="content pb-4">Trong chủ điểm <span v-if="dataDetailSkill" style="font-weight: 600;">{{dataDetailSkill.name}}</span>, con đã hoàn thành bài kiểm tra gồm 4 kỹ năng:</div>
        <comment-component  v-if="dataDetailSkill && dataDetailSkill.overall.listening_score" :type="'Listening'" :item="dataDetailSkill"/>
        <comment-speaking-component v-if="dataDetailSkill && dataDetailSkill.overall.speaking_score" :item="dataDetailSkill" />
        <comment-component  v-if="dataDetailSkill && dataDetailSkill.overall.reading_score" :type="'Reading'" :item="dataDetailSkill"/>
        <comment-component  v-if="dataDetailSkill && dataDetailSkill.overall.writing_score" :type="'Writing'" :item="dataDetailSkill"/>
        <comment-component :type="'Note'" :item="dataDetailSkill"/>
        <div class="text-center pt-4 name-teacher"><span>Cô giáo: {{dataDetailSkill && dataDetailSkill.comment.teacher_name ?  dataDetailSkill.comment.teacher_name : '-'}}</span></div>
      </div>
    </div>
  </v-card>
</template>

<script>
import BlendedCareRepository from '@/services/BlendedCareRepository';
import { mapState } from 'vuex';
import CommentComponent from './CommentComponent.vue';
import CommentSpeakingComponent from './CommentSpeakingComponent.vue';

export default {
  props: {
    curriculumID: {
      type: Number,
      default: null,
    },
    lessonID: {
      type: Number,
      default: null,
    },
  },
  components: { CommentComponent, CommentSpeakingComponent },
  updated() {
    const element = document.getElementsByClassName('v-dialog');
    element[0].id = 'custom-dialog';
  },
  computed: {
    ...mapState('student_detail_bt', ['filterForm', 'studentBlendedTutorDetail']),
    dataFilter() {
      return {
        curriculumID: this.curriculumID,
        lessonID: this.lessonID,
      };
    },
    totalCorrectQuestion() {
      if (this.dataDetailSkill) {
        const listeningScore = this.dataDetailSkill.overall.listening_score !== null ? parseInt(this.dataDetailSkill.overall.listening_score.split('/')[0], 0) : 0;
        const speakingScore = this.dataDetailSkill.overall.speaking_score !== null ? parseInt(this.dataDetailSkill.overall.speaking_score.split('/')[0], 0) : 0;
        const readingScore = this.dataDetailSkill.overall.reading_score !== null ? parseInt(this.dataDetailSkill.overall.reading_score.split('/')[0], 0) : 0;
        const writingScore = this.dataDetailSkill.overall.writing_score !== null ? parseInt(this.dataDetailSkill.overall.writing_score.split('/')[0], 0) : 0;
        return listeningScore + speakingScore + readingScore + writingScore;
      }
      return 0;
    },
    totalQuestion() {
      if (this.dataDetailSkill) {
        const listeningScore = this.dataDetailSkill.overall.listening_score !== null ? parseInt(this.dataDetailSkill.overall.listening_score.split('/')[1], 0) : 0;
        const speakingScore = this.dataDetailSkill.overall.speaking_score !== null ? parseInt(this.dataDetailSkill.overall.speaking_score.split('/')[1], 0) : 0;
        const readingScore = this.dataDetailSkill.overall.reading_score !== null ? parseInt(this.dataDetailSkill.overall.reading_score.split('/')[1], 0) : 0;
        const writingScore = this.dataDetailSkill.overall.writing_score !== null ? parseInt(this.dataDetailSkill.overall.writing_score.split('/')[1], 0) : 0;
        return listeningScore + speakingScore + readingScore + writingScore;
      }
      return 0;
    },
  },
  data() {
    return {
      dataScoreDetail: null,
      dataDetailSkill: null,
    };
  },
  async created() {
    await this.getScoreDetail();
  },
  watch: {
    dataFilter: {
      deep: true,
      handler() {
        this.getScoreDetail();
      },
    },
  },
  methods: {
    async getScoreDetail() {
      const params = {
        'filters[lms_core_user_id]': this.studentBlendedTutorDetail.lms_core_user_id,
        'filters[subject_id]': 5,
        'filters[curriculum_id]': this.curriculumID,
        'filters[lesson_id]': this.lessonID,
        'filters[type]': 2,
        'sorts[lesson_start_time]': 'desc',
        'filters[$between__lesson_start_time]':
          `['${this.filterForm.dateTime[0]} 00:00:00', '${this.filterForm.dateTime[1]} 23:59:59']`,
        'filters[$eq__type_curriculum]': 'online',
        attrs: [
          'lms_core_user_id',
          'subject_id',
          'time',
          'class_code',
          'lesson_id',
          'name',
          'lesson_start_time',
          'no_question',
          'no_correct',
          'reading_score',
          'listening_score',
          'writing_score',
          'speaking_score',
          'id',
        ],
      };
      const res = await BlendedCareRepository.getScoreDetail(params);
      if (res && res.data) {
        // eslint-disable-next-line prefer-destructuring
        this.dataScoreDetail = res.data[0];
      }
      const result = await BlendedCareRepository.getScoreDetailtoSkill(params);
      if (result && result.data) {
        // eslint-disable-next-line prefer-destructuring
        this.dataDetailSkill = result.data[0];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-height {
  max-height: 98vh;
  overflow-y: auto;
}
.header-score {
  border-radius: 12px;
  border: 2px solid #ffa670;
  background: #ffe6d6;
  padding: 16px;
  .content-score {
    border-radius: 12px;
    background: #fff;
    padding: 16px;
    text-align: center;
    .title {
      color: #191919;
      font-feature-settings: "clig" off, "liga" off;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%; /* 24px */
    }
    .score {
      color: #5e606e;
      font-feature-settings: "clig" off, "liga" off;
      font-size: 36px;
      font-style: normal;
      font-weight: 600;
      line-height: 150%;
    }
    .tag-ex {
      border-radius: 24px;
      background: var(--Orange---Bg--Alerts, #fff1dc);
      color: #ff6500;
      padding: 4px 16px;
      width: 30%;
      margin: auto;
    }
  }
  .content-skill {
    border-radius: 12px;
    background: #fff;
    padding: 16px 10px;
    text-align: center;
    width: 23%;
    .title {
      color: #2a2c3c;
      font-feature-settings: "clig" off, "liga" off;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%; /* 21px */
    }
    .score {
      color: #5e606e;
      font-feature-settings: "clig" off, "liga" off;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 150%;
    }
  }
}
.body-score {
  padding: 16px;
  .feedback {
    color: #191919;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%; /* 30px */
    padding-bottom: 16px;
    text-align: center;
  }
  .content {
    color: #191919;
    font-feature-settings: 'clig' off, 'liga' off;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 21px */
  }
  .name-teacher {
    color: #191919;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%; /* 21px */
  }
}
</style>
